export default __webpack_public_path__ + "static/media/m1903.c6958222.svg";